import { MST_CLC_TYP, GetMstClcTyp } from './MstClcTypModels';
import { JudgeSettingSelectType } from "./JudgeSettingSelectModel";
import { SET_PART_DIS } from '../components/Pages/MeasureSetting/PartialDischargeCollection/PartialDischargeCollection';
//傾向管理グループテーブルタイプ
export type TM_TRD_GROUP_SET = {
  GROUP_NO: number;
  GROUP_NAME: string;
  DSP_FLG: number;
  DSP_COLOR: number;
  AUT_UPDATE: number;
  DSP_SPAN: number;
};
export type V_TREND_SETTING_ITEM = {
  GROUP_NO: number;
  PEN_NO: number;
  DSP_FLG: number;
  DSP_COLOR: number;
  GRP_LOW: number;
  GRP_HIGH: number;
  SCALE_ON: number;
  PLC_NO: number;
  AI_CARD: number;
  AI_CH: number;
  TYP_NO: number;
  MCLC_TYP_ID: number;
  SET_NO: number;
  DEV_INDEX: number,
  DEV_NO: string;
  DEV_NAME: string;
  ITM_NAME_NO: number,
  ITM_NAME: string;
  EMC_ITM_NAME_NO: number;
  EMC_ITM_NAME: string;
  EMC_UNIT: string;
  CLC: number;
  KIND: number;
  KIND_NO: number;
  UNIT: string;
  RH: number;
  RL: number;
  MUL: number;
  SPEED: number;
  MES_NAME: string;
  LOG_INT: number;
}

//リアルタイムトレンドグループタイプ
export type RT_TRD_GROUP_SET = {
  GROUP_NO: number;
  GROUP_NAME: string;
  DSP_FLG: number;
  DSP_COLOR: number;
  AUT_UPDATE: number;
  DSP_SPAN: number;
}
export type V_RT_TREND_SETTING_ITEM = {
  GROUP_NO: number;
  PEN_NO: number;
  DSP_FLG: number;
  DSP_COLOR: number;
  GRP_LOW: number;
  GRP_HIGH: number;
  SCALE_ON: number;
  PLC_NO: number;
  AI_CARD: number;
  AI_CH: number;
  TYP_NO: number;
  MCLC_TYP_ID: number;
  SET_NO: number;
  DEV_INDEX: number,
  DEV_NO: string;
  DEV_NAME: string;
  ITM_NAME_NO: number,
  ITM_NAME: string;
  CLC: number;
  RT_LMT_H: number;
  RT_LMT_HH: number;
  KIND: number;
  KIND_NO: number;
  UNIT: string;
  RH: number;
  RL: number;
  COL_RT_LMT_H: number;
  COL_RT_LMT_HH: number;
  MUL: number;
  SPEED: number;
  MES_NAME: string;
  LOG_INT: number;
}

//電流診断グループタイプ
export type PH_CUR_GROUP_SET = {
  GROUP_NO: number;
  GROUP_NAME: string;
  DSP_FLG: number;
  DEV_INDEX: number;
  PLC_NO: number;
  SET_NO_R: number;
  SET_NO_S: number;
  SET_NO_T: number;
}

//生波形比較グループタイプ
export type SIG_CMP_GROUP_SET = {
  GROUP_NO: number;
  GROUP_NAME: string;
  DSP_FLG: number;
  PLC_NO1: number;
  SET_NO1: number;
  PLC_NO2: number;
  SET_NO2: number;

  //時間項目追加
  Time_No1: string;
  Time_No2: string;

}

//生波形比較(コナン)グループタイプ
export type SIGC_CMP_GROUP_SET = {
  GROUP_NO: number;
  GROUP_NAME: string;
  DSP_FLG: number;
  PLC_NO1: number;
  SET_NO1: number;
  PLC_NO2: number;
  SET_NO2: number;

  //時間項目追加
  Time_No1: string;
  Time_No2: string;

}

//FFT 比較グループタイプ
export type FFT_CMP_GROUP_SET = {
  GROUP_NO: number;
  GROUP_NAME: string;
  DSP_FLG: number;
  PLC_NO1: number;
  SET_NO1: number;
  PLC_NO2: number;
  SET_NO2: number;
  PLC_NO3: number;
  SET_NO3: number;
  KIND1: number;
  KIND2: number;
  KIND3: number;

  //時間項目追加
  Time_No1: string;
  Time_No2: string;
  Time_No3: string;

}

//FFT 比較(コナン)グループタイプ
export type FFTC_CMP_GROUP_SET = {
  GROUP_NO: number;
  GROUP_NAME: string;
  DSP_FLG: number;
  PLC_NO1: number;
  SET_NO1: number;
  PLC_NO2: number;
  SET_NO2: number;
  PLC_NO3: number;
  SET_NO3: number;
  KIND1: number;
  KIND2: number;
  KIND3: number;

  //時間項目追加
  Time_No1: string;
  Time_No2: string;
  Time_No3: string;

}

//XY分布グループタイプ
export type XY_CMP_GROUP_SET = {
  GROUP_NO: number;
  GROUP_NAME: string;
  DSP_FLG: number;
  DEV_INDEX: number;
  PLC_NO_X: number;
  SET_NO_X: number;
  PLC_NO_Y: number;
  SET_NO_Y: number;
  YEAR_FLG: number;
  MONTH_FLG: number;
  START_DATE: string;
  END_DATE: string;
  START_MONTH1: number;
  END_MONTH1: number;
  DSP_COLOR1: number;
  START_MONTH2: number;
  END_MONTH2: number;
  DSP_COLOR2: number;
  START_MONTH3: number;
  END_MONTH3: number;
  DSP_COLOR3: number;
  START_MONTH4: number;
  END_MONTH4: number;
  DSP_COLOR4: number;
}

//リアルタイムトレンド
export type RT_TRD_ITEM_SET = {
  GROUP_NO: number;
  PEN_NO: number;
  DSP_FLG: number;
  DSP_COLOR: number;
  PLC_NO: number;
  AI_CARD: number;
  AI_CH: number;
  GRP_LOW: number;
  GRP_HIGH: number;
  SCALE_ON: number;
  TYP_NO: number;
  CLC: number;
  RT_LMT_H: number;
  RT_LMT_HH: number;
  SET_NO: number;
}

//傾向管理
export type TM_TRD_ITEM_SET = {
  GROUP_NO: number;
  PEN_NO: number;
  DSP_FLG: number;
  DSP_COLOR: number;
  PLC_NO: number;
  AI_CARD: number;
  AI_CH: number;
  GRP_LOW: number;
  GRP_HIGH: number;
  SCALE_ON: number;
  TYP_NO: number;
  CLC: number;
  SET_NO: number;
}

export type KIND_NO_NAME_SET = {
  SPEED: number;
  NAME_NO: number;
  MES_NAME: string;
}

/**
 * 傾向管理画面データ選択リスト
 */
export type TMGroupSelectDataType = {
  trdItemSet: TM_TRD_ITEM_SET;
  trdGroupSet: TM_TRD_GROUP_SET;
};

/**
 * リアルタイムトレンド画面データ選択リスト
 */
export type RTGroupSelectDataType = {
  trdItemSet: RT_TRD_ITEM_SET;
  trdGroupSet: RT_TRD_GROUP_SET;
};


//全グループリスト情報（画面名付）
export type GroupListComModel = {
  FormID: Number;
  FormName: string;
  GroupNo: Number;
  GroupName: string;
  DispFlg: Number;
};


// 電流診断 選択肢
export type PhaseCurrentSelectItem = {
  GROUP_NAME: string;
  DEV_INDEX: number;
  PLC_NO: number;
  SET_NO_R: number;
  SET_NO_S: number;
  SET_NO_T: number;
  KIND_R: string;
  KIND_S: string;
  KIND_T: string;
  ITEM_R: string;
  ITEM_S: string;
  ITEM_T: string;
}

// 生波形/FFT比較 選択肢
export type DeviceSelectItem = {
  DEV_INDEX: number;
  DEV_NO: string;

  MeasureSelects: MeasureSelectItem[];
}
export type MeasureSelectItem = {
  MES_NAME: string;
  NAME_NO: number;
  FFT_INVALID: number;
  ItemSelects: ItemSelectItem[];
}
export type ItemSelectItem = {
  ITM_NAME: string;
  PLC_NO: number;
  SET_NO: number;
  KIND: number;
}

// XY比較 選択肢
export type XYDeviceSelectItem = {
  DEV_INDEX: number;
  DEV_NO: string;

  ItemSelects: XYItemSelectItem[];
}
export type XYItemSelectItem = {
  PLC_NO: number;
  SET_NO: number;
  ITM_NAME: string;
  NAME_NO: number;
  MES_NAME: string;
  SPEED: number;

  index: number;
}

export type TrendSettingParameter = {
  MeasKinds: ComboItem[];
  KIND_NO_NAME_SETs: KIND_NO_NAME_SET[];
  DeviceLists: ComboItem[];
  ItemLists: ComboItem[];
  DataKinds: ComboItem[];
  AlarmKinds: ComboItem[];
  MClcTypes: ComboItem[];
  AlarmLimits: JudgeInfo[];
  DeviceUnitInfos: PlcInfo[];
  ColSetInfos: ColSetInfo[];
  JudgeSetSelect: JudgeSettingSelectType[];
  SetPartDisList: SET_PART_DIS[];
}
export type ComboItem = {
  Key: number;
  Disp: string;
  Tag?: any; //付加情報
}
export type JudgeInfo = {
  PLC_NO: number;
  AI_CARD: number;
  AI_CH: number;
  CLC_TYP: number;
  ALM_TYP_NO: number;
  WRN_LIM: number;
  ALM_LIM: number;
  MCLC_TYP_ID: number;
}
export type PlcInfo = {
  PLC_NO: number;
  AiCards: AiCardInfo[]
}
export type AiCardInfo = {
  AI_CARD: number;
  AiChs: AiChInfo[];
}
export type AiChInfo = {
  AI_CH: number;
  Unit: string;
}
export type ColSetInfo = {
  KIND_NO: number;
  DEV_INDEX: number;
  ITM_NAME_NO: number;
  CLC: number;
  PLC_NO: number;
  AI_CARD: number;
  AI_CH: number;
  SET_NO: number;
  SPEED: number;
  UNIT: string;
  VALID: number;
}



export type V_GROUP_DEVICE = {

  DEV_INDEX: number;/// 機器インデックスを取得または設定します。
  DEV_NO: string; /// 機器番号を取得または設定します。
  DEV_NAME: string; /// 機器名称を取得または設定します。
  PLC_NO: number; /// PLC 番号を取得または設定します。
  AI_CARD: number; /// AI カードを取得または設定します。
  AI_CH: number; /// CH 番号を取得または設定します。
  SET_NO: number;  /// 設定 No を取得または設定します。
  SPEED: number;  /// 低速/高速区分を取得または設定します。
  NAME_NO: number;  /// 計測種別 No を取得または設定します。
  MES_NAME: string;  /// 計測種別を取得または設定します。
  ITM_NAME_NO: number;  /// 項目名称 No を取得または設定します。
  ITM_NAME: string;  /// 項目名称を取得または設定します。

}



//Json受取タイプ
export type GroupListType = {
  TM_TRD_GROUP_SETs: TM_TRD_GROUP_SET[];
  RT_TRD_GROUP_SETs: RT_TRD_GROUP_SET[];
  PH_CUR_GROUP_SETs: PH_CUR_GROUP_SET[];
  SIG_CMP_GROUP_SETs: SIG_CMP_GROUP_SET[];
  SIGC_CMP_GROUP_SETs: SIGC_CMP_GROUP_SET[];
  FFT_CMP_GROUP_SETs: FFT_CMP_GROUP_SET[];
  FFTC_CMP_GROUP_SETs: FFTC_CMP_GROUP_SET[];
  XY_CMP_GROUP_SETs: XY_CMP_GROUP_SET[];
  GroupListsComModels: GroupListComModel[];

  TrendSettings: TrendSettingParameter;

  PhCurSelectItems: PhaseCurrentSelectItem[];

  DeviceSelects: DeviceSelectItem[];
  DeviceConanSelects: DeviceSelectItem[];
  XYDeviceSelects: XYDeviceSelectItem[];
};


//傾向管理のグループ一覧を取得
export const GetTrendGroupList = (): Promise<GroupListType> => {
  return new Promise((resolve, reject) => {
    fetch("api/TrendGroupList")
      .then((res) => res.json())
      .then((result: GroupListType) => {
        console.debug([`fetch api/TrendGroupList OK `, result]);
        if (TrendGroupListValidate(result)) resolve(result);

        reject('Invalidate response');
      },
        (error) => {
          console.error(error);
          reject(error);
        }
      );
  });
};

//グループ一覧取得データ検証
const TrendGroupListValidate = (data: GroupListType): boolean => {
  if (data.TM_TRD_GROUP_SETs == undefined) {
    console.debug(`TrendGroupListValidate NG `);
    return false;
  }
  console.debug(`TrendGroupListValidate OK `);
  return true;
};

// 傾向管理のグループ一覧を取得
export const GetTrendGroupTableByItemSet = (): Promise<TMGroupSelectDataType[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/GetTrendGroupTableByItemSet")
      .then((res) => res.json())
      .then((result: TMGroupSelectDataType[]) => {
        if (TrendGroupTableByItemSetValidate(result)) resolve(result);

        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

// リアルタイムトレンドの取得データ検証
const TrendGroupTableByItemSetValidate = (data: TMGroupSelectDataType[]): boolean => {
  if (data[0].trdGroupSet === undefined) {
    return false;
  }
  return true;
};

// 傾向管理設定項目
export const GetTrendSetting = (no: number): Promise<V_TREND_SETTING_ITEM[]> => {
  return new Promise((resolve, reject) => {
    fetch(`api/TrendGroupSetting/${no}`)
      .then((res) => res.json())
      .then((result: V_TREND_SETTING_ITEM[]) => {
        resolve(result);
      })
      .catch(reason => reject(reason));
  });
}
// 傾向管理設定更新
export const PutTrendGroupSetting = (group: TM_TRD_GROUP_SET, items: V_TREND_SETTING_ITEM[]): Promise<number> => {
  console.debug(["PutTrendGroupSetting, group,items", group, items])
  return new Promise((resolve, reject) => {
    fetch("api/TrendGroupSetting", {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ Group: group, Items: items }),
    })
      .then((res) => res.json())
      .then((result: { Count: number }) => {
        resolve(result.Count);
      })
      .catch(reason => reject(reason));
  });
}

//リアルタイムトレンドのグループ一覧を取得
export const GetRealTimeTrendGroupList = (): Promise<GroupListType> => {
  return new Promise((resolve, reject) => {
    fetch("api/RealTimeTrendGroupList")
      .then((res) => res.json())
      .then((result: GroupListType) => {
        console.debug(`fetch api/RealTimeTrendGroupList OK `);
        console.debug(result);
        if (RealTimeTrendGroupListValidate(result)) resolve(result);

        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};
//グループ一覧取得データ検証
const RealTimeTrendGroupListValidate = (data: GroupListType): boolean => {
  if (data.RT_TRD_GROUP_SETs == undefined) {
    console.debug(`TrendGroupListValidate NG `);
    return false;
  }
  console.debug(`TrendGroupListValidate OK `);
  return true;
};


// リアルタイムトレンドのグループ一覧を取得
export const GetRealtimeGroupList = (): Promise<GroupListType> => {
  return new Promise((resolve, reject) => {
    fetch("api/RealtimeGroupList")
      .then((res) => res.json())
      .then((result: GroupListType) => {
        console.debug(`fetch api/RealtimeGroupList OK `);
        console.debug(result);
        if (RealtimeGroupListValidate(result)) resolve(result);

        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};
// リアルタイムトレンドの取得データ検証
const RealtimeGroupListValidate = (data: GroupListType): boolean => {
  if (data.RT_TRD_GROUP_SETs == undefined) {
    console.debug(`RealtimeGroupListValidate NG `);
    return false;
  }
  console.debug(`RealtimeGroupListValidate OK `);
  return true;
};


// リアルタイムトレンドのグループ一覧を取得
export const GetRealTimeTrendGroupTableByItemSet = (): Promise<RTGroupSelectDataType[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/GetRealTimeTrendGroupTableByItemSet")
      .then((res) => res.json())
      .then((result: RTGroupSelectDataType[]) => {
        if (RealTimeTrendGroupTableByItemSetValidate(result)) resolve(result);

        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

// リアルタイムトレンドの取得データ検証
const RealTimeTrendGroupTableByItemSetValidate = (data: RTGroupSelectDataType[]): boolean => {
  if (data[0].trdGroupSet === undefined) {
    return false;
  }
  return true;
};

// リアルタイムトレンド設定項目
export const GetRealtimeSetting = (no: number): Promise<V_RT_TREND_SETTING_ITEM[]> => {
  return new Promise((resolve, reject) => {
    fetch(`api/RealtimeGroupSetting/${no}`)
      .then((res) => res.json())
      .then((result: V_RT_TREND_SETTING_ITEM[]) => {
        resolve(result);
      })
      .catch(reason => reject(reason));
  });
}
// リアルタイムトレンド設定更新
export const PutRealtimeGroupSetting = (group: RT_TRD_GROUP_SET, items: V_RT_TREND_SETTING_ITEM[]): Promise<number> => {
  return new Promise((resolve, reject) => {
    fetch("api/RealtimeGroupSetting", {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ Group: group, Items: items }),
    })
      .then((res) => res.json())
      .then((result: { Count: number }) => {
        resolve(result.Count);
      })
      .catch(reason => reject(reason));
  });
}

/**
 * 電流診断グループ設定画面用情報取得
 * @returns
 */
export const GetPhaseCurrentGroupList = (): Promise<GroupListType> => {
  return new Promise((resolve, reject) => {
    fetch("api/PhaseCurrentGroupList")
      .then((res) => res.json())
      .then((result: GroupListType) => {
        console.debug('fetch api/PhaseCurrentGroupList OK');
        console.debug(result);
        if (PhaseCurrentGroupListValidate(result)) resolve(result);

        reject('Invalidate response');
      })
      .catch(reason => reject(reason));
  });
}

const PhaseCurrentGroupListValidate = (data: GroupListType): boolean => {
  if (data.PH_CUR_GROUP_SETs == undefined) {
    console.debug('PhaseCurretGroupListValidate NG');
    return false;
  }
  if (data.PhCurSelectItems == undefined) {
    console.debug('PhCurSelectItem Validate NG');
    return false;
  }
  console.debug('PhaseCurrentGroupListValidete OK');
  return true;
}

export const PutPhaseCurrentGroupList = (data: PH_CUR_GROUP_SET[]): Promise<number> => {
  return new Promise((resolve, reject) => {
    fetch("api/PhaseCurrentGroupList", {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result: { Count: number }) => {
        resolve(result.Count);
      })
      .catch(reason => reject(reason));
  });
}

/**
 * 生波形比較グループテーブルを Select
 * @returns
 */
export const GetRawWaveformsComparisonGroupList = (): Promise<GroupListType> => {
  return new Promise((resolve, reject) => {
    fetch("api/RawWaveformsComparisonGroupList")
      .then((res) => res.json())
      .then((result: GroupListType) => {
        console.debug('fetch api/RawWaveformsComparisonGroupList OK');
        console.debug(result);
        if (RawWaveformsComparisonGroupListValidate(result)) resolve(result);

        reject('Invalidate response');
      })
      .catch(reason => reject(reason));
  });
}

const RawWaveformsComparisonGroupListValidate = (data: GroupListType): boolean => {
  if (data.SIG_CMP_GROUP_SETs == undefined) {
    console.debug('RawWaveformsComparisonValidate NG');
    return false;
  }
  if (data.DeviceSelects == undefined) {
    console.debug('RawWaveformsComparisonSelectItem Validate NG');
    return false;
  }
  console.debug('RawWaveformsComparisonValidate OK');
  return true;
}

/**
 * 生波形比較グループテーブルの更新
 * @param data
 * @returns
 */
export const PutRawWaveformsComparisonGroupList = (data: SIG_CMP_GROUP_SET[]): Promise<number> => {
  return new Promise((resolve, reject) => {
    fetch("api/RawWaveformsComparisonGroupList", {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result: { Count: number }) => {
        resolve(result.Count);
      })
      .catch(reason => reject(reason));
  });
}

/**
 * 生波形比較(コナン)グループテーブルを Select
 * @returns
 */
export const GetRawWaveformsComparisonConanGroupList = (): Promise<GroupListType> => {
  return new Promise((resolve, reject) => {
    fetch("api/RawWaveformsComparisonConanGroupList")
      .then((res) => res.json())
      .then((result: GroupListType) => {
        console.debug('fetch api/RawWaveformsComparisonConanGroupList OK');
        console.debug(result);
        if (RawWaveformsComparisonConanGroupListValidate(result)) resolve(result);

        reject('Invalidate response');
      })
      .catch(reason => reject(reason));
  });
}

const RawWaveformsComparisonConanGroupListValidate = (data: GroupListType): boolean => {
  if (data.SIGC_CMP_GROUP_SETs == undefined) {
    console.debug('RawWaveformsComparisonConanValidate NG');
    return false;
  }
  if (data.DeviceSelects == undefined) {
    console.debug('RawWaveformsComparisonConanSelectItem Validate NG');
    return false;
  }
  console.debug('RawWaveformsComparisonConanValidate OK');
  return true;
}

/**
 * 生波形比較(コナン)グループテーブルの更新
 * @param data
 * @returns
 */
export const PutRawWaveformsComparisonConanGroupList = (data: SIGC_CMP_GROUP_SET[]): Promise<number> => {
  return new Promise((resolve, reject) => {
    fetch("api/RawWaveformsComparisonConanGroupList", {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result: { Count: number }) => {
        resolve(result.Count);
      })
      .catch(reason => reject(reason));
  });
}

/**
 * FFT 比較グループテーブルを Select
 * @returns
 */
export const GetFFTComparisonGroupList = (): Promise<GroupListType> => {
  return new Promise((resolve, reject) => {
    fetch("api/FFTComparisonGroupList")
      .then((res) => res.json())
      .then((result: GroupListType) => {
        console.debug('fetch api/FFTComparisonGroupList OK');
        console.debug(result);
        if (FFTComparisonGroupListValidate(result)) resolve(result);

        reject('Invalidate response');
      })
      .catch(reason => reject(reason));
  });
}

const FFTComparisonGroupListValidate = (data: GroupListType): boolean => {
  if (data.FFT_CMP_GROUP_SETs == undefined) {
    console.debug('FFTComparisonValidate NG');
    return false;
  }
  if (data.DeviceSelects == undefined) {
    console.debug('FFTComparisonSelectItem Validate NG');
    return false;
  }
  console.debug('FFTComparisonValidate OK');
  return true;
}

/**
 * FFT比較グループテーブルの更新
 * @param data
 * @returns
 */
export const PutFFTComparisonGroupList = (data: FFT_CMP_GROUP_SET[]): Promise<number> => {
  return new Promise((resolve, reject) => {
    fetch("api/FFTComparisonGroupList", {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result: { Count: number }) => {
        resolve(result.Count);
      })
      .catch(reason => reject(reason));
  });
}

/**
 * FFT 比較(コナン)グループテーブルを Select
 * @returns
 */
export const GetFFTComparisonConanGroupList = (): Promise<GroupListType> => {
  return new Promise((resolve, reject) => {
    fetch("api/FFTComparisonConanGroupList")
      .then((res) => res.json())
      .then((result: GroupListType) => {
        console.debug('fetch api/FFTComparisonConanGroupList OK');
        console.debug(result);
        if (FFTComparisonConanGroupListValidate(result)) resolve(result);

        reject('Invalidate response');
      })
      .catch(reason => reject(reason));
  });
}

const FFTComparisonConanGroupListValidate = (data: GroupListType): boolean => {
  if (data.FFTC_CMP_GROUP_SETs == undefined) {
    console.debug('FFTComparisonConanValidate NG');
    return false;
  }
  if (data.DeviceConanSelects == undefined) {
    console.debug('FFTComparisonConanSelectItem Validate NG');
    return false;
  }
  console.debug('FFTComparisonConanValidate OK');
  return true;
}

/**
 * FFT比較(コナン)グループテーブルの更新
 * @param data
 * @returns
 */
export const PutFFTComparisonConanGroupList = (data: FFTC_CMP_GROUP_SET[]): Promise<number> => {
  return new Promise((resolve, reject) => {
    fetch("api/FFTComparisonConanGroupList", {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result: { Count: number }) => {
        resolve(result.Count);
      })
      .catch(reason => reject(reason));
  });
}

/**
 * XYのグループテーブル設定取得
 * @returns 
 */
export const GetXYComparisonGroupList = (): Promise<GroupListType> => {
  return new Promise((resolve, reject) => {
    fetch("api/XYComparisonGroupList")
      .then((res) => res.json())
      .then((result: GroupListType) => {
        console.debug(['fetch api/XYComparisonGroupList OK', result]);
        if (XYComparisonGroupListValidate(result)) resolve(result);

        reject('Invalidate response');
      })
      .catch(reason => {
        console.error(reason);
        reject(reason)
      });
  });
}

const XYComparisonGroupListValidate = (data: GroupListType): boolean => {
  if (data.XY_CMP_GROUP_SETs == undefined) {
    console.debug('XYComparisonValidate NG');
    return false;
  }
  if (data.XYDeviceSelects == undefined) {
    console.debug('XYComparisonSelectItem Validate NG');
    return false;
  }
  console.debug('XYComparisonValidate OK');
  return true;
}

/**
 * XYのグループテーブルの更新
 * @param data 
 * @returns 
 */
export const PutXYComparisonGroupList = (data: XY_CMP_GROUP_SET[]): Promise<number> => {
  return new Promise((resolve, reject) => {
    fetch("api/XYComparisonGroupList", {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result: { Count: number }) => {
        resolve(result.Count);
      })
      .catch(reason => reject(reason));
  });
}

export const GetAllGroupList = (deviceIndex: Number): Promise<GroupListType> => {
  return new Promise((resolve, reject) => {
    fetch(`api/GroupList?deviceindex=${deviceIndex}`)
      .then((res) => res.json())
      .then((result: GroupListType) => {
        console.debug(result);
        if (AllGroupListValidate(result)) resolve(result);

        reject('Invalidate response');
      })
      .catch(reason => reject(reason));
  });
}

const AllGroupListValidate = (data: GroupListType): boolean => {
  console.debug(data.GroupListsComModels.length);
  if (data.GroupListsComModels == undefined) {
    console.debug('AllGroupListValidate NG');
    return false;
  }
  console.debug('AllGroupListValidate OK');
  return true;
}

export const GetGroupDeviceSelect = (): Promise<V_GROUP_DEVICE[]> => {
  return new Promise((resolve, reject) => {
    fetch(`api/GroupDeviceSelect`)
      .then((res) => res.json())
      .then((result: V_GROUP_DEVICE[]) => {
        console.debug(result);
        if (GroupDeviceSelectValidate(result)) resolve(result);

        reject('Invalidate response');
      })
      .catch(reason => reject(reason));
  });
}

const GroupDeviceSelectValidate = (data: V_GROUP_DEVICE[]): boolean => {
  if (data == undefined) {
    console.debug('AllGroupListValidate NG');
    return false;
  }
  console.debug('AllGroupListValidate OK');
  return true;
}
